export default function Services() {
  return (
    <section
      id="services"
      className="relative w-full bg-[#E9E3D5] flex flex-col items-center justify-start 
                 py-[8vh] sm:py-[6vh] md:py-[14vh] lg:py-[16vh] 
                 font-[Poppins] overflow-hidden"
    >
      {/* === Judul === */}
      <h2 className="text-[#2D435B] text-2xl sm:text-xl md:text-6xl lg:text-7xl font-extrabold text-center mb-10 sm:mb-8 md:mb-32 leading-tight">
        Our Services
      </h2>

      {/* === Isi Layanan === */}
      <div className="flex flex-wrap justify-center items-start gap-3 sm:gap-4 md:gap-14 text-[#2D435B] w-full max-w-[1000px] px-3 sm:px-4 md:px-6">
        {/* === Gedung Rendah === */}
        <div className="flex flex-col items-center w-[110px] sm:w-[120px] md:w-[250px]">
          <img
            src="/buildings.png"
            alt="Gedung Rendah"
            className="w-4 sm:w-5 md:w-10 h-4 sm:h-5 md:h-10 mb-1 sm:mb-2 md:mb-3"
          />
          <div className="bg-[#2D435B] text-white p-1 sm:p-2 md:p-5 h-[90px] sm:h-[105px] md:h-[190px] w-full rounded-2xl text-center shadow-md hover:scale-105 transition-transform duration-300 flex flex-col justify-center">
            <h3 className="text-[7px] sm:text-[9px] md:text-[15px] font-bold mb-1">
              Gedung Rendah
            </h3>
            <p className="text-[5px] sm:text-[6px] md:text-[12px] font-medium leading-snug">
              Perencanaan struktur untuk gedung perkantoran, sekolah, dan fasilitas umum dengan efisiensi dan keamanan maksimal.
            </p>
          </div>
        </div>

        {/* === Gedung Tinggi === */}
        <div className="flex flex-col items-center w-[110px] sm:w-[120px] md:w-[250px]">
          <img
            src="/construction.png"
            alt="Gedung Tinggi"
            className="w-4 sm:w-5 md:w-10 h-4 sm:h-5 md:h-10 mb-1 sm:mb-2 md:mb-3"
          />
          <div className="bg-[#2D435B] text-white p-1 sm:p-2 md:p-5 h-[90px] sm:h-[105px] md:h-[190px] w-full rounded-2xl text-center shadow-md hover:scale-105 transition-transform duration-300 flex flex-col justify-center">
            <h3 className="text-[7px] sm:text-[9px] md:text-[15px] font-bold mb-1">
              Gedung Tinggi
            </h3>
            <p className="text-[5px] sm:text-[6px] md:text-[12px] font-medium leading-snug">
              Desain struktur profesional untuk gedung bertingkat tinggi dengan mempertimbangkan risiko, keamanan, dan ketahanan jangka panjang.
            </p>
          </div>
        </div>

        {/* === Struktur Baja dan Lainnya === */}
        <div className="flex flex-col items-center w-[110px] sm:w-[120px] md:w-[250px]">
          <img
            src="/hook.png"
            alt="Struktur Baja"
            className="w-4 sm:w-5 md:w-10 h-4 sm:h-5 md:h-10 mb-1 sm:mb-2 md:mb-3"
          />
          <div className="bg-[#2D435B] text-white p-1 sm:p-2 md:p-5 h-[90px] sm:h-[105px] md:h-[190px] w-full rounded-2xl text-center shadow-md hover:scale-105 transition-transform duration-300 flex flex-col justify-center">
            <h3 className="text-[7px] sm:text-[9px] md:text-[15px] font-bold mb-1">
              Struktur Baja dan Lainnya
            </h3>
            <p className="text-[5px] sm:text-[6px] md:text-[12px] font-medium leading-snug">
              Solusi struktur baja modern yang kuat, fleksibel, serta layanan untuk berbagai kebutuhan konstruksi lain sesuai permintaan klien.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
